var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2E117F;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-thumbs-up",
    className: "st0",
    d: "M318.21,492.95H201.36c-19.36,0-35.05,15.69-35.05,35.05c0,0.01,0,0.03,0,0.04 V878.6c0,19.36,15.69,35.05,35.05,35.05c0,0,0,0,0,0h116.86c19.36,0,35.05-15.69,35.05-35.05l0,0V528.03 c0.02-19.36-15.65-35.06-35.01-35.09C318.24,492.95,318.23,492.95,318.21,492.95z M259.8,855.23c-19.36,0-35.05-15.69-35.05-35.05 s15.69-35.05,35.05-35.05c19.33,0,35,15.64,35.05,34.97c0.04,19.36-15.61,35.08-34.97,35.13 C259.85,855.23,259.82,855.23,259.8,855.23z M727.23,284.76c0,61.96-37.93,96.72-48.6,138.11h148.59 c47.16,0.14,85.68,37.72,86.98,84.87c-0.06,26.67-10.2,52.34-28.39,71.86l-0.16,0.16c15.5,38.49,10.38,82.21-13.6,116.07 c11.31,38.1,2.24,79.35-24,109.2c6.84,21.99,3.55,45.88-8.97,65.2c-29.82,42.82-103.71,43.43-166.19,43.43h-4.15 c-60.89-2.57-120.49-18.38-174.65-46.33c-24.03-12.36-50.05-20.38-76.87-23.7c-9.54-0.22-17.17-7.99-17.22-17.53V513.91 c0-4.67,1.87-9.15,5.19-12.44c57.87-57.18,82.75-117.72,130.18-165.23c19.87-24.83,32.68-54.55,37.08-86.04 c6.52-27.02,20.1-84.42,49.58-84.42c35.05,0,105.16,11.75,105.16,118.97H727.23z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTips);
export default __webpack_public_path__ + "static/media/tips.59790e34396d09d0baaed211507bcf5a.svg";
export { ForwardRef as ReactComponent };